// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aRfF","newExpiryDate":"styles_newExpiryDate__sinvE","footer":"styles_footer__3ktAm"};